import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';

@Component({
  selector: 'app-consumer-banner',
  templateUrl: './consumer-banner.component.html',
  styleUrls: ['./consumer-banner.component.scss']
})
export class ConsumerBannerComponent extends FeaturesBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}